/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { addDependencies } from './dependenciesAdd.generated.js';
import { typedDependencies } from './dependenciesTyped.generated.js';
import { unaryPlusDependencies } from './dependenciesUnaryPlus.generated.js';
import { createCumSumTransform } from '../../factoriesAny.js';
export var cumsumTransformDependencies = {
  addDependencies,
  typedDependencies,
  unaryPlusDependencies,
  createCumSumTransform
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/esm/entry/dependenciesAny/dependenciesCumSumTransform.generated.js
// module id = 1345
// module chunks = 2